// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".thumbnail[data-v-5da56ed1]{padding-top:80%}.thumbnail-image[data-v-5da56ed1]{background-size:100% auto;background-repeat:no-repeat;background-position:50%}@media (min-width: 768px){.thumbnail-md[data-v-5da56ed1]{padding-top:59.875%}.w-164px[data-v-5da56ed1]{width:164px}.w-250px[data-v-5da56ed1]{width:250px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
